// TOP LEVEL IMPORTS
import React from 'react';
import { Route, Redirect } from 'react-router-dom';

// EXPORTED COMPONENT
// ==============================
const PublicRoute = props => {
  const {
    currentUser, component: Component, path, layout: Layout, ...rest
  } = props;

  if (currentUser && currentUser.roles && currentUser.roles.includes('appAdmin')) {
    return <Redirect to="/admin" />;
  }

  return (
    <Route
      {...rest}
      path={path}
      render={args => (
        <Layout currentUser={currentUser}>
          <Component currentUser={currentUser} {...args} />
        </Layout>
      )}
    />
  );
};

// PROPS
// ==============================
PublicRoute.defaultProps = {};

// EXPORT
// ==============================
export default PublicRoute;



// WEBPACK FOOTER //
// ./src/components/route-components/PublicRoute/index.js